import React, { createContext, useReducer } from "react";

/**
 * 建立 Context
 */
export const FreqContext = createContext({
	state: { freqs: [] },
	dispatch: () => {
		console.warn("未初始化 FreqContext Provider");
	},
});

/**
 * 初始狀態
 */
const initialState = {
	freqs: [], // 存放FREQ資料
};

/**
 * Reducer 處理邏輯
 */
function freqReducer(state, action) {
	switch (action.type) {
		case "INITIAL_FREQS":
			return {
				...state,
				freqs: action.payload,
			};

		case "UPDATE_FREQS":
			// console.log('更新FREQ資料:', action.payload);
			return {
				...state,
				freqs: action.payload,
			};

		default:
			return state;
	}
}

/**
 * Provider 負責提供 freq 資料
 */
export const FreqProvider = ({ children }) => {
	const [state, dispatch] = useReducer(freqReducer, initialState);

	return (
		<FreqContext.Provider value={{ state, dispatch }}>
			{children}
		</FreqContext.Provider>
	);
};

export default FreqProvider;
